<div class="w-100 h-100" [ngStyle]="{'display': isLoading ? 'none' : 'block'}" [ngClass]="{ 'shadow-box p-3': showShadowBox }">
  <figure class="highcharts-figure d-flex align-items-center justify-content-center">
    <highcharts-chart id="{{container}}" [style]="'width: 100%; height:'+height+'px; display: block'"></highcharts-chart>
  </figure>
</div>

<p-skeleton *ngIf="isLoading" width="100%" [height]="height+'px'"></p-skeleton>